import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=2ab4a2cb&scoped=true&"
import script from "./Copy.vue?vue&type=script&lang=js&"
export * from "./Copy.vue?vue&type=script&lang=js&"
import style0 from "./Copy.vue?vue&type=style&index=0&id=2ab4a2cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab4a2cb",
  null
  
)

export default component.exports